module.exports = __webpack_public_path__ + "static/img/techs2.5654dd67.png";